import * as Yup from 'yup';

export const getCorrectiveActionCloseSchema = () => {
  return Yup.object().shape({
    reason: Yup.string().required('Reason is required'),
  });
};
